import { Skeleton } from '~/shared/ui/SkeletonList'

export function LoadingBlock() {
  return (
    <>
      <Skeleton animated $height={96} style={{ marginBottom: '44px' }} />
      <Skeleton animated $height={24} style={{ marginBottom: '16px' }} />
      <Skeleton animated $height={56} style={{ marginBottom: '32px' }} />

      <Skeleton animated $height={48} style={{ marginBottom: '60px' }} />
      <Skeleton animated $height={24} style={{ marginBottom: '11px' }} />

      <Skeleton animated $height={56} style={{ marginBottom: '0' }} />
    </>
  )
}
